<template>
  <bly-permission-field :label="label" :hint="hint" :error="error" :required="required">
    <select
      :value="normalizedValue"
      :multiple="multiple"
      :disabled="disabled"
      class="w-full rounded-sm border bg-black/20 text-xs text-[#e5eefc] outline-none transition-[border-color,box-shadow] duration-150"
      :class="[
        multiple ? 'min-h-[140px] px-2 py-1.5' : 'h-8 max-h-8 min-h-8 px-2.5',
        error ? 'border-[#ff8a65]' : 'border-[#2a333d] focus:border-[#ffaa00] focus:shadow-[0_0_0_2px_rgba(255,170,0,0.18)]'
      ]"
      @change="onChange"
    >
      <option v-if="!multiple && placeholder" value="" disabled>{{ placeholder }}</option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </bly-permission-field>
</template>

<script>
export default {
  name: "NativeSelectField",
  props: {
    value: {
      type: [String, Number, Array],
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedValue() {
      return this.multiple ? (Array.isArray(this.value) ? this.value : []) : this.value ?? "";
    },
  },
  methods: {
    onChange(event) {
      if (!this.multiple) {
        this.$emit("input", event.target.value);
        return;
      }

      const values = [...event.target.options]
        .filter((option) => option.selected)
        .map((option) => option.value);
      this.$emit("input", values);
    },
  },
};
</script>
